import {
  ActionRef,
  ActionTransactionSubTypes,
  ActionType,
  ActionCategory,
} from 'further-types/lp/action';
import { ActionTransactionSubType } from 'further-types/lp/action';
import { TransactionOperation } from 'further-types/lp/transaction';

type TransactionType = {
  transactionTypeId: string;
  operationType: TransactionOperation;
  transactionSubType: ActionTransactionSubType;
};

type DefaultAccountMapping = {
  actionRef: ActionRef;
  actionType: ActionType;
  actionCategory: ActionCategory;
  customActionType?: string | null;
  customActionTypeId?: string | null;
  isInUse?: boolean;
  transactionTypes: Array<TransactionType>;
};

const isSingleSided = (transactionType: TransactionType) =>
  transactionType.transactionSubType !==
  ActionTransactionSubTypes.CreditDebitPair;

const buildTransactionPairs = (defaultValues: Array<DefaultAccountMapping>) => {
  return defaultValues
    .map((defaultMapping) => {
      const {
        actionRef,
        actionType,
        actionCategory,
        transactionTypes: transactionTypesFromDefaultMapping,
        customActionType,
        customActionTypeId,
        isInUse,
      } = defaultMapping;

      const debitTransactionType = transactionTypesFromDefaultMapping.find(
        (transactionType) =>
          transactionType.operationType === TransactionOperation.Debit,
      );
      const creditTransactionType = transactionTypesFromDefaultMapping.find(
        (transactionType) =>
          transactionType.operationType === TransactionOperation.Credit,
      );

      if (
        debitTransactionType &&
        creditTransactionType &&
        debitTransactionType.transactionSubType ===
          ActionTransactionSubTypes.CreditDebitPair &&
        creditTransactionType.transactionSubType ===
          ActionTransactionSubTypes.CreditDebitPair
      ) {
        return {
          actionRef,
          actionType,
          actionCategory,
          customActionType,
          customActionTypeId,
          isInUse,
          transactionSubType: ActionTransactionSubTypes.CreditDebitPair,
          debitTransactionTypeId: debitTransactionType.transactionTypeId,
          creditTransactionTypeId: creditTransactionType.transactionTypeId,
        };
      }

      return transactionTypesFromDefaultMapping.flatMap((transactionType) => ({
        actionRef,
        actionType,
        actionCategory,
        customActionType,
        customActionTypeId,
        isInUse,
        transactionSubType: transactionType.transactionSubType,
        debitTransactionTypeId:
          transactionType.operationType === TransactionOperation.Debit
            ? transactionType.transactionTypeId
            : isSingleSided(transactionType)
            ? null
            : '',
        creditTransactionTypeId:
          transactionType.operationType === TransactionOperation.Credit
            ? transactionType.transactionTypeId
            : isSingleSided(transactionType)
            ? null
            : '',
      }));
    })
    .flat();
};

export default buildTransactionPairs;
